import s from './style.module.scss';
import { Link, useLoaderData, Form } from 'react-router-dom';


import { loaderPostFetch, csAmount } from '../util';
import PaymentSuccess from './credit';
import TransferFailed from './debit';

export const imagePath = `/wp-user/`;

export async function sloader({ params }) {
  const formData = new FormData();
  formData.append('getreceipt', 'getreceipt');

  console.log(params);
  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
    formData.append('trans',params?.trans);
  }
  const res = await loaderPostFetch(`api/users.php`, formData);

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...res };
}

function ReceiptPage() {

  const {data: b} = useLoaderData();
  return (<> {b?.transaction_type!="debit"?<PaymentSuccess
      refNumber={b?.ref2}
      status={b?.status||''}
      sender={b?.name}
      type="Credit"
      dateTime={b?.date}
      amount={b?.amount}
    />:
    <TransferFailed
      bankName={b?.bank}
      name={b?.act_hold_name}
      accountNumber={b?.act_no}
      country={b?.country}
      type={b?.type}
      dateTime={b?.date}
      status={b?.status2||''}
      transactionId={b?.ref2}
      amount={b?.amount}
    />}</>
  );
}

export default ReceiptPage;